import { teApi } from 'yxt-biz-pc/packages/api';

// 讲师预约授课基本信息
export const getSubscribeBaseinfo = (targetId) => {
  return teApi.get(`/appt/backend/${targetId}/info`);
};

// 讲师预约授课转正
export const passteSubscribe = (teId) => {
  return teApi.put(`/appt/backend/beofficical/${teId}`);
};

// 讲师预约授课取消资格
export const rejectTeSubscribe = (teId) => {
  return teApi.put(`/appt/backend/cancel/${teId}`);
};

// 讲师预约授课催促
export const urgeTeSubscribe = (targetId) => {
  return teApi.put(`/appt/backend/urge/${targetId}`);
};

// 预约讲师列表
export const getSubscribeTeList = (query) => {
  return teApi.post('/appt/backend/users', query);
};

// 添加预约讲师
export const addSubscribeTeList = (targetId, body) => {
  return teApi.post(`/appt/backend/addte/${targetId}`, body);
};
